import { BACKEND_ENDPOINT } from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getClientGeneralConfig(
    userId,
    clientId,
    type = 'generalConfig',
) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/generalConfig/getById`, {
            params: {userId, clientId, type},
        })
        .then(res => (res.data ? res.data : null))
}

export function updateUserWatchConfig(userId, id, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/updateWatchConfig`, data, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
}

export function getUserWatchConfig(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/user/getUserWatchConfig`, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
}

export function getLocationOptions(hospitalId, userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/user/getLocationOptions`, {
            params: {hospitalId, userId},
        })
        .then(res => (res.data ? res.data : null))
}

export function getGeofencingLocation(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/getGeofencingLocation`, data, {})
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function scanNetwork(id) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/networkSuggestion/scanNetwork`, null, {
            params: {id},
        })
        .then(res => (res.data ? res.data : null))
}

export function getNetworkSuggestions(id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/networkSuggestion/getNetworkSuggestions`, {
            params: {id},
        })
        .then(res => (res.data ? res.data : null))
}

export function addNetwork(data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/networkSuggestion/addNetworkSuggestion`,
            data,
            {
                params: {},
            },
        )
        .then(res => (res.data ? res.data : null))
}

export function removeNetwork(id) {
    return axiosInstance
        .delete(
            `${BACKEND_ENDPOINT}/networkSuggestion/deleteNetworkSuggestion`,
            {
                params: {id},
            },
        )
        .then(res => (res.data ? res.data : null))
}

export function createOrUpdateWatchConfig(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/generalConfig/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
}
